import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { lang } from '../../il8n/lang';
import { connect } from 'react-redux';
import { changeProducts } from '../../Actions/Index';
import { mapATGLoc, truncate } from '../../utils';
import {atgBase, atgBrand} from '../../const';
import Caro from '../Carousels/Caro/Caro';
import './Productcaro.css';

/**
 * ProductCarousel - 
 * this component is drawing from the product listing feed. 
 * if this brand has more than 15(maxproducts) products, you should be using a product page instead.
 * @constructor
 */

class Productcaro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      maxproducts: 15
    };
    this.populateProducts = this.populateProducts.bind(this);
  }
  componentWillMount() {
    this.populateProducts();
  }
  /**
  * Populate all products in redux.
  */
  populateProducts(){
    // let feedUrl = `${atgBase}rest/service/sm/${mapATGLoc()}/catalog/ProductList?root=${atgBrand}`;

    const appendFeed = () => {
      let loc = mapATGLoc()
      
      let appendloc = loc === 'us' ? '' : `_${loc}`;
      let feedUrl = `${atgBase}rest/service/sm/${mapATGLoc()}/catalog/ProductList?root=${atgBrand}${appendloc}`;

      return feedUrl;

    }

    fetch(appendFeed()).then(function(res) {
      let contentType = res.headers.get('content-type');
      if(contentType && contentType.indexOf('application/json') !== -1) {
        return res.json().then(function(json) {
          this.props.dispatch(changeProducts(json));
        }.bind(this));
      } else {
        console.warn('Product Feed Not Loaded');
      }
    }.bind(this));
    

  }



  /**
  * Render all the products
  * @return {jsx} Products.
  */
  renderProducts(){
    let {products} = this.props;
    // console.log(products.products[0].images[0])
    if(products){
      return(
        <div className="flex-container productCaro_section">
          <div className="productCaro_heading">
            <h2> {lang.home.productCaro} | 
              <Link to={ `/${lang.getLanguage()}/toys`} >
                  {lang.home.viewAll}
                </Link>
              </h2>
          </div>
          <Caro respSlidesToShow={1} respSlidesToShowMed={3} slidesToShow={4} framePadding='0px' cellSpacing={10} insertClass="mod-products" frameOverflow={'false'} color={'dark'}>
            {products.products.map((product, index) => {
              if(index < this.state.maxproducts){
                return(
                  <Link className='caro-card' to={`/${lang.getLanguage()}/toys/${product.id}`} key={`product-${index}`} itemProp='itemListElement'>
                  <div className='product'>
                  {product.images[0] && (
                    <img className='product__img' itemProp='image' src={product.images[0].large} alt={product.name}/>
                  )}
                  <h2 className='product__title' itemProp='name'>{truncate(product.name, 40)}</h2>
                  <button>{lang.details}</button>   
                  </div>
                </Link>
                )
              }
            })}
          </Caro>
        </div>
      )
    }
    
  }
  render(){
    let {products} = this.props;
    return (
      <div>
        {products.products ? this.renderProducts() : <div className='loading'>{lang.loading}</div>}
      </div>
    );
  }
}

function mapStateToProps(state){
  let { lang, products } = state;
  return {
    lang,
    products
  };
}

export default connect(mapStateToProps)(Productcaro);
